import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Card, CardContent, Typography, LinearProgress } from '@material-ui/core';

import { LAYER_TYPE } from 'yeself-common/typings/guide/LayerEnum';
import { FEATURE_FLAG_NAMES } from 'yeself-common/typings/FeatureFlags';

import { omitGuidesByLayerType } from 'yeself-client-common/utils/GuideUtils';

import { selectGuideLanguageCode } from 'Console/utils/guideUtils';

import GuideListItem from './GuideListItem';

const styles = (theme) => ({
    root: {
        padding: 0,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    noGuides: {
        width: '100%',
        height: 300,
        backgroundColor: 'white',
    },
});

const GuidesList = ({
    classes,
    intl,
    list = [],
    isLoading,
    duplicateGuide,
    removeGuide,
    applicationsList,
    appId,
    updateGuide,
    editGuideHost,
    searchTerm,
    contentLanguage,
    featureFlags,
}) => {
    const filterGuides = (item, searchTerm) => {
        if (!item) {
            return false;
        }

        return item.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    };

    const handleFilterGuides = (guide) => {
        const guideLanguageCode = selectGuideLanguageCode(guide, contentLanguage.code);

        if (!searchTerm) {
            return true;
        }

        if (!guide.name || !guide.description) {
            return false;
        }

        return (
            filterGuides(guide.name[guideLanguageCode], searchTerm) ||
            filterGuides(guide.description[guideLanguageCode], searchTerm)
        );
    };

    const filteredGuides = list.filter(handleFilterGuides);

    const filteredGuidesByFeatureFlag =
        filteredGuides.length > 0 && featureFlags[FEATURE_FLAG_NAMES.COLLECTORS]
            ? filteredGuides
            : filteredGuides.length > 0 &&
              omitGuidesByLayerType(filteredGuides, [
                  LAYER_TYPE.ERROR_COLLECTOR,
                  LAYER_TYPE.INTERACTION_COLLECTOR,
              ]);

    if (!isLoading && list.length === 0) {
        return (
            <Grid container justify="center" alignItems="center" className={classes.noGuides}>
                <Typography variant="body1">
                    <FormattedMessage
                        id="Guides.list.empty"
                        defaultMessage="Go ahead and create your first guide"
                    />
                </Typography>
            </Grid>
        );
    }

    if (!isLoading && filteredGuides.length === 0) {
        return (
            <Grid container justify="center" alignItems="center" className={classes.noGuides}>
                <Typography variant="body1">
                    <FormattedMessage
                        id="Guides.list.noResults"
                        defaultMessage="There are no guides for given search criteria"
                    />
                </Typography>
            </Grid>
        );
    }

    if (!isLoading && filteredGuidesByFeatureFlag.length > 0) {
        return (
            <div className={classes.guidesListWrapper}>
                {filteredGuidesByFeatureFlag.map((guide) => (
                    <GuideListItem
                        key={guide.id}
                        guide={guide}
                        intl={intl}
                        duplicateGuide={duplicateGuide}
                        removeGuide={removeGuide}
                        applicationsList={applicationsList}
                        appId={appId}
                        updateGuide={updateGuide}
                        editGuideHost={editGuideHost}
                        guideLanguage={selectGuideLanguageCode(guide, contentLanguage.code)}
                    />
                ))}
            </div>
        );
    }

    return (
        <Card>
            <CardContent>
                <Grid container justify="center" alignContent="center">
                    <Grid container alignContent="flex-start">
                        <Grid item xs={12}>
                            <LinearProgress className="yeself-linear-loading" />
                        </Grid>
                        <Grid item xs={12}>
                            <LinearProgress className="yeself-linear-loading" />
                        </Grid>
                        <Grid item xs={6}>
                            <LinearProgress className="yeself-linear-loading" />
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default withStyles(styles)(injectIntl(GuidesList));
